import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CategorySelect } from "@/components/CategorySelect";

export function LineItemDialog({ open, setOpen, editing, form, setForm, phases, vendors, categories, submit, saving }) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="rounded-none">
        <DialogHeader><DialogTitle className="font-heading">{editing ? "Edit Cost Item" : "Add Cost Item"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4" data-testid="line-item-form">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label className="label-caps">Phase</Label>
              <Select value={form.phase_id} onValueChange={(v) => setForm({ ...form, phase_id: v })}>
                <SelectTrigger className="mt-2 rounded-none" data-testid="item-phase-select"><SelectValue /></SelectTrigger>
                <SelectContent>
                  {phases.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="label-caps">Category</Label>
              <CategorySelect categories={categories} value={form.category}
                onChange={(v) => setForm({ ...form, category: v })}
                testId="item-category-select" placeholder="Select category" />
            </div>
          </div>
          <div>
            <Label className="label-caps">Description</Label>
            <Input required value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })}
              data-testid="item-description-input" className="mt-2" />
          </div>
          <div>
            <Label className="label-caps">Vendor</Label>
            <Select value={form.vendor_id || "none"} onValueChange={(v) => setForm({ ...form, vendor_id: v })}>
              <SelectTrigger className="mt-2 rounded-none" data-testid="item-vendor-select"><SelectValue placeholder="Select vendor" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="none">— None —</SelectItem>
                {vendors.map((v) => <SelectItem key={v.id} value={v.id}>{v.name}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label className="label-caps">Budget ($)</Label>
              <Input type="number" step="0.01" value={form.budget_amount} onChange={(e) => setForm({ ...form, budget_amount: e.target.value })}
                data-testid="item-budget-input" className="mt-2 font-mono-fig" />
            </div>
            <div>
              <Label className="label-caps">Actual ($)</Label>
              <Input type="number" step="0.01" value={form.actual_amount} onChange={(e) => setForm({ ...form, actual_amount: e.target.value })}
                data-testid="item-actual-input" className="mt-2 font-mono-fig" />
            </div>
          </div>
          <div>
            <Label className="label-caps">Status</Label>
            <Select value={form.status} onValueChange={(v) => setForm({ ...form, status: v })}>
              <SelectTrigger className="mt-2 rounded-none" data-testid="item-status-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="not_started">Not started</SelectItem>
                <SelectItem value="in_progress">In progress</SelectItem>
                <SelectItem value="completed">Completed</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <DialogFooter>
            <Button type="submit" disabled={saving} data-testid="item-submit-button" className="rounded-none">
              {saving ? "Saving…" : editing ? "Update" : "Add Item"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
